import React, { useState, useEffect } from 'react';

const OnepageMenuItems = (props) => {
    const { menuItem1, menuItem2, menuItem3, menuItem4, menuItem8 } = props;

    const [activeSection, setActiveSection] = useState('');

    // Handle scroll tracking
    useEffect(() => {
        const sections = [
            { id: 'rs-header', menu: 'home' },
            { id: 'rs-about', menu: 'about' },
            { id: 'rs-service', menu: 'service' },
            { id: 'rs-methodology', menu: 'methodology' },
            { id: 'rs-contact', menu: 'contact' }
        ];

        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100; // Offset for better detection
            
            for (const section of sections) {
                const element = document.getElementById(section.id);
                if (element) {
                    const offsetTop = element.offsetTop;
                    const offsetHeight = element.offsetHeight;
                    
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section.menu);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId, menu) => {
        setActiveSection(menu);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <React.Fragment>
            {menuItem1 && (
                <li className={activeSection === 'home' ? "current-menu-item" : ""}>
                    <a onClick={() => scrollToSection('rs-header', 'home')}>
                        {menuItem1}
                    </a>
                </li>
            )}
            {menuItem2 && (
                <li className={activeSection === 'about' ? "current-menu-item" : ""}>
                    <a onClick={() => scrollToSection('rs-about', 'about')}>
                        {menuItem2}
                    </a>
                </li>
            )}
            {menuItem3 && (
                <li className={activeSection === 'service' ? "current-menu-item" : ""}>
                    <a onClick={() => scrollToSection('rs-service', 'service')}>
                        {menuItem3}
                    </a>
                </li>
            )}
            {menuItem4 && (
                <li className={activeSection === 'methodology' ? "current-menu-item" : ""}>
                    <a onClick={() => scrollToSection('rs-methodology', 'methodology')}>
                        {menuItem4}
                    </a>
                </li>
            )}
            {menuItem8 && (
                <li className={activeSection === 'contact' ? "current-menu-item" : ""}>
                    <a onClick={() => scrollToSection('rs-contact', 'contact')}>
                        {menuItem8}
                    </a>
                </li>
            )}
        </React.Fragment>
    );
}

export default OnepageMenuItems;